<template>
  <div class="home-page">
    <Navbar />
    <v-container>
      <!-- <v-dialog v-model="expireProject" width="80%">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            รายการที่สิ้นสุดรับฟังคำวิจารณ์ กรุณาติดตามข้อมูลโครงการ
          </v-card-title>

          <v-col
            cols="12"
            sm="12"
            md="12"
            style="padding-top: 10px; padding-left: 0%;"
          >
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหาข้อมูล"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="torProject"
                :search="search"
                style="padding-bottom: 50px;"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-cog-outline
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
              ปิดหน้าจอ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- <v-dialog v-model="expireProject" width="80%">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            รายการที่สิ้นสุดรับฟังคำวิจารณ์ กรุณาติดตามข้อมูลโครงการ
          </v-card-title>

          <v-col
            cols="12"
            sm="12"
            md="12"
            style="padding-top: 10px; padding-left: 0%;"
          >
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหาข้อมูล"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="torProject"
                :search="search"
                style="padding-bottom: 50px;"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-cog-outline
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
              ปิดหน้าจอ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-container>

    <v-container>
      <v-row justify="center" align="center">
        <v-col
          lg="3"
          md="3"
          cols="6"
          sm="6"
          v-for="(item, index) in items"
          :key="index"
          ><v-hover v-slot:default="{ hover }">
            <v-card
              class="mx-auto"
              color="grey lighten-4"
              style="min-height: 200px;"
            >
              <span>
                <v-container>
                  <v-row justify="center" align="center">
                    <v-col class="text-center"
                      ><v-icon x-large>{{ item.icon }}</v-icon></v-col
                    >
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center"
                      ><h2>{{ item.title }}</h2></v-col
                    >
                  </v-row>
                </v-container>
              </span>
              <v-expand-transition>
                <v-container
                  @click="clickMenu(item.path)"
                  v-if="hover"
                  class="d-flex transition-slow-in-slow-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%"
                >
                  <v-row justify="center" align="center">
                    <v-col>{{ item.descript }}</v-col>
                  </v-row>
                </v-container>
              </v-expand-transition>
            </v-card>
          </v-hover></v-col
        >
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Navbar from "../components/navbarBox";
// import axios from "axios";
export default {
  components: { Navbar },
  data: () => ({
    torProject: [],
    search: "",
    expireProject: true,
    items: [
      {
        icon: "mdi-account-multiple-plus",
        title: "เพิ่มผู้ใช้งาน",
        descript: "เพิ่มข้อมูลผู้ใช้งาน(สำหรับผู้ดูเเลระบบเท่านั้น)",
        path: "/adduserviews",
      },
      {
        icon: "mdi-book-plus-multiple",
        title: "เพิ่มข้อมูลประกาศ ToR",
        descript: "เพิ่มประกาศข้อมูล ToR จากเว็บจัดซื้อจัดจ้างภาครัฐ",
        path: "/addtor",
      },
      {
        icon: "mdi-briefcase-plus-outline",
        title: "เพิ่มข้อมูลประกาศเชิญชวน",
        descript: "เพิ่มข้อมูลประกาศเชิญชวน จากเว็บจัดซื้อจัดจ้างภาครัฐ",
        path: "/addinvite",
      },
      {
        icon: "mdi-account-plus-outline",
        title: "สมัครสมาชิก",
        descript: "สมัครสมาชิก",
        path: "/newregist",
      },
      {
        icon: "mdi-magnify",
        title: "ค้นหาข้อมูล",
        descript: "ค้นหาข้อมูลที่บัญทึกเข้าสู่ระบบ",
        path: "/",
      },
      {
        icon: "mdi-magnify-scan",
        title: "ตรวจสอบข้อมูลการเพิ่มข้อมูล",
        descript: "หน้าจอตรวจสอบข้อมูลการเพิ่มข้อมูล",
        path: "/confirmlistdata",
      },
      {
        icon: "mdi-checkbox-multiple-marked-circle-outline",
        title: "ยืนยันข้อมูล",
        descript: "ยืนยันข้อมูลสำหรับเเจ้งเตือนลูกค้า",
        path: "/conferimadddata",
      },
      {
        icon: "mdi-checkbox-multiple-marked-circle-outline",
        title: "ตรวจสอบคะเเนน",
        descript: "ตรวจสอบคะเเนนพนักงาน",
        path: "/conferimadddata",
      },
      {
        icon: "mdi-briefcase-variant-outline",
        title: "เเสดงข้อมูลTOR",
        descript: "เเสดงรายการประกาศร่าง ToR ทั้งหมด",
        path: "/showdatatoradmin",
      },
      {
        icon: "mdi-briefcase-variant-outline",
        title: "เเสดงข้อมูลเชิญชวน",
        descript: "เเสดงรายการประกาศเชิญชวนทั้งหมด",
        path: "/showdatainviteadmin",
      },
      {
        icon: "mdi-account-convert",
        title: "เเสดงข้อมูลรายชื่อพนักงาน",
        descript: "เเสดงรายชื่อพนักงานเข้าสู่ระบบทั้งหมด",
        path: "/showuserviews",
      },
      {
        icon: "mdi-account-hard-hat",
        title: "เเสดงข้อมูลลูกค้าพาร์ทเนอร์",
        descript: "เเสดงข้อมูลลูกค้าพาร์ทเนอร์ทั้งหมด",
        path: "/showpartnersviews",
      },
      {
        icon: "mdi-alpha-l-box-outline",
        title: "จัดการ Line Token",
        descript: "การจัดการ Line Token สำหรับการเเจ้งเตือนกลุ่มลูกค้า",
        path: "/linetoken",
      },
      {
        icon: "mdi-bell-plus",
        title: "จัดการโฆษณา",
        descript:
          "หน้าที่จัดการการส่งโฆษณาหรือประกาศต่างๆให้กับลูกค้าผ่านทางกลุ่ม Line",
        path: "/ads",
      },
      {
        icon: "mdi-google-chrome",
        title: "ระบบการจัดซื้อจัดจ้างภาครัฐ",
        descript: "ระบบการจัดซื้อจัดจ้างภาครัฐ",
        path: "/gprocurement",
      },
       {
        icon: "mdi-google-drive",
        title: "ส่งไฟล์PDFรายวัน",
        descript: "ส่งไฟล์PDFรายวัน",
        path: "/drive",
      },
      {
        icon: "mdi-logout-variant",
        title: "ออกจากระบบ",
        descript: "ออกจากระบบ",
        path: "/login",
      },
    ],
    headers: [
      { text: "รหัสโครงการ", value: "project_code" },
      { text: "ชื่อโครงการ", value: "project_name", width: "40%" },
      { text: "จังหวัด", value: "name_th" },
      { text: "วันที่เริ่มประกาศ", value: "tor_date_start", width: "9%" },
      { text: "วันที่สิ้นสุดประกาศ", value: "tor_date_end", width: "9%" },

      { text: "ชื่อพนักงานคีย์", value: "created_by" },
      { text: "สถานะโครงการ", value: "namestatus", width: "9%" },
      { text: "ติดตามล่าสุด", value: "updated_status_at", width: "9%" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  mounted() {
    // axios
    //   .post(this.api + "/post/expire_project", {
    //     created_by: localStorage.getItem("username"),
    //   })
    //   .then((res) => {
    //     this.torProject = [];
    //     this.torProject = res.data.response;
      
    //     if (res.data.status) {
    //       if (this.torProject[0] === undefined) {
    //         this.expireProject = false;
    //       }
    //     } else {
    //       alert("เกิดความผิดพลาดในการแสดงข้อมูล");
    //     }
    //   });
  },
  methods: {
    clickMenu(path) {
      if (path === "/gprocurement") {
        window.open("http://www.gprocurement.go.th/new_index.html", "_blank");
      } 
      else if (path === "/drive") {
        window.open("https://drive.google.com/drive/folders/1OlA4MI98OVRjpUO80j-d6LNFk2JOSCE2?usp=sharing", "_blank");
      }
      else if (path === "/login") {
        localStorage.removeItem("username");
        localStorage.removeItem("fullname");
        localStorage.removeItem("role");
        localStorage.removeItem("ipaddress");
        this.$router.push("/login");
      } else if (path === "/conferimadddata") {
        if (localStorage.getItem("role") === "Admin") {
          this.$router.push(path);
        } else {
          alert("คุณไม่มีสิทธิ์เข้าถึง");
        }
      } else if (path === "/adduserviews") {
        if (localStorage.getItem("role") === "Admin") {
          this.$router.push(path);
        } else {
          alert("คุณไม่มีสิทธิ์เข้าถึง");
        }
      } else if (path === "/showuserviews") {
        if (localStorage.getItem("role") === "Admin") {
          this.$router.push(path);
        } else {
          alert("คุณไม่มีสิทธิ์เข้าถึง");
        }
      } else {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.9;
  position: absolute;
  width: 100%;
  cursor: pointer;
}
</style>
